function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var Erase = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#DBE1DD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.333 5.333l5.334 5.334M10.667 5.333l-5.334 5.334",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

export { Erase };
//# sourceMappingURL=Erase.js.map